/* istanbul ignore file */
import { Routes } from 'react-router-dom';
import { Page404 } from 'framework/statusPages';
import useAuthenticationService from 'infrastructure/security/authentication/authenticationService';
import { GlobalProtectedRoute } from 'framework/authorization';
import { Route } from 'framework/routing';
import { ProtectedRouter } from 'infrastructure/routing';
import { getCostAccountingListUrl, getCostAccountingRouterPath, useCostAccountingRoute } from './route';
import { READ_COST_CENTER_REPORT } from 'domain/finance/costAccounting/shared/costAccountingService';
import CostAccountingDashboard from 'domain/finance/costAccounting/dashboard/CostAccountingDashboard';

const CostAccountingRouter = () => {
  const { isAuthenticated } = useAuthenticationService();
  const { listRoute } = useCostAccountingRoute();

  return (
    <ProtectedRouter basePath={getCostAccountingListUrl()}>
      <Routes>
        <Route
          path={listRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={READ_COST_CENTER_REPORT}>
              <CostAccountingDashboard />
            </GlobalProtectedRoute>
          }
        />

        <Route path="*" element={<Page404 isAuthenticated={isAuthenticated} />} />
      </Routes>
    </ProtectedRouter>
  );
};

CostAccountingRouter.getRouterPath = getCostAccountingRouterPath;

export default CostAccountingRouter;
